import AuthService from '../../service';
const ResourceCenter = {
  getResourceCenter(page,search){
    return AuthService.get(`/resource_center/resource_centers?page=${page}&search=${search}`);
  },
  showResourceCenter(id){
    return AuthService.get(`/resource_center/resource_centers/${id}`);
  },
  createResourceCenter(data){
    return AuthService.post(`/resource_center/resource_centers`,data);
  },
  updateResourceCenter(id,data){
    return AuthService.put(`/resource_center/resource_centers/${id}`,data);
  },
  deleteResourceCenter(id){
    return AuthService.delete(`/resource_center/resource_centers/${id}`);
  },
}
export default ResourceCenter
